import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTenancy } from '@/contexts/TenancyContext';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
// Use the same import pattern as in auditor-sidebar-config.tsx
import { faClipboardCheck, faExclamationTriangle, faServer, faBook } from '@awesome.me/kit-269fbef2e2/icons/duotone/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AuditorLayout } from './components/AuditorLayout';
import { AuditorSidebarConfig, DEFAULT_AUDITOR_CONFIG } from './components/auditor-sidebar-config';

// CSS for auditor view
import './auditor-view.css';

const AuditorView: React.FC = () => {
  const { activeTenancy } = useTenancy();
  const navigate = useNavigate();
  const [config, setConfig] = useState<AuditorSidebarConfig>(DEFAULT_AUDITOR_CONFIG);
  
  useEffect(() => {
    // Here you could load configuration from an API or localStorage
    // For now, we'll use the default configuration
    
    // Stay at /auditor-view/ instead of redirecting
  }, [config, navigate]);
  
  return (
    <>
      <div className="page-container">
        <div className="glass-card max-w-full overflow-x-auto">
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-2xl font-semibold">Auditor Dashboard</h1>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
            {config.tabs.filter(tab => tab.enabled).map(tab => (
              <Card key={tab.key} className="glass-card cursor-pointer hover:shadow-md transition-shadow" onClick={() => navigate(tab.path)}>
                <CardHeader className="pb-2">
                  <CardTitle className="text-lg flex items-center gap-2">
                    <FontAwesomeIcon icon={tab.icon} className="text-primary" />
                    {tab.label}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-sm text-muted-foreground">
                    {tab.key === 'soa' && 'View Statement of Applicability (SOA) controls and their implementation status.'}
                    {tab.key === 'policy' && 'Browse and review all organization policies in a secure, read-only mode.'}
                    {tab.key === 'risk-register' && 'Examine risk register entries and their assessments.'}
                    {tab.key === 'asset-register' && 'Browse all registered assets and their details.'}
                    {tab.key === 'assurance-library' && 'Browse all assurance tasks and evidence in a secure, read-only view for auditors.'}
                    {tab.key === 'msg' && 'Access Management System Guidelines documentation.'}
                  </p>
                  <Button 
                    variant="outline" 
                    size="sm" 
                    className="mt-4"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(tab.path);
                    }}
                  >
                    View {tab.label}
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default AuditorView;
